<app-heading [title]="'Applied job postings'" [button]="false" [isbreadcrumb]="false" [showToggle]="false"></app-heading>

<div class="card">
    <p-table [value]="jobs"
        dataKey="_id"
        [expandedRowKeys]="expandedRows"
        [totalRecords]="jobsCount"
        styleClass="p-datatable-sm p-datatable-sm--normal"
        [paginator]="true"
        [rows]="rows"
        [first]="page * rows"
        (onPage)="onPageChange($event)">
        <ng-template pTemplate="header">
            <tr>
                <th>Name</th>
                <th>Start date</th>
                <th>Location</th>
                <th>Rate</th>
                <th style="width: 5rem"></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-job let-expanded="expanded">
            <tr>
                <td>{{ job.title }}</td>
                <td>{{ job.startDate | date: 'MM/dd/yyyy' }}</td>
                <td>{{ getLocation(job) }}</td>
                <td>
                    <ng-container *ngIf="job.rateRange?.rateMinimum">
                        ${{ job.rateRange.rateMinimum }} - ${{ job.rateRange.rateMaximum }}{{ job.rateOption === 'hourly' ? '/hour' : '/year' }}
                    </ng-container>
                    <ng-container *ngIf="job.rate && !job.rateRange?.rateMinimum">
                        {{ job.rate }}{{ job.rateOption === 'hourly' ? '/hour' : '/year' }}
                    </ng-container>
                    <ng-container *ngIf="!job.rate && job.rateOption === 'experience'">Depends On Experience</ng-container>
                    <ng-container *ngIf="job.rateOption === '' || job.rateOption === 'none'">Not Specified</ng-container>
                </td>
                <td>
                    <p-button [ngStyle]="{'margin-left': 'auto'}" [pTooltip]="expanded? 'Close' : 'Expand'" 
                        tooltipPosition="top" type="button" [pRowToggler]="job" pRipple [text]="true"
                            [rounded]="true" [plain]="true" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-up'" 
                            [size]="'large'" class="row-toggler" />
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="rowexpansion" let-job>
            <tr>
                <td colspan="7" class="surface-100">
                    <div class="py-3">
                        <div>
                            <div class="flex flex-column gap-3">
                                <div class="grid">
                                    <div class="col-6 lg:col-4 flex flex-column">
                                        <span class="text-xs text-primary-900 font-medium">Start date</span>
                                        <span class="text-black-alpha-60">{{ job.startDate | date: 'MM/dd/yyyy' }}</span>
                                    </div>
                                    <div class="col-6 lg:col-4 flex flex-column">
                                        <span class="text-xs text-primary-900 font-medium">Rate</span>
                                        <span class="text-black-alpha-60">
                                            <ng-container *ngIf="job.rateRange?.rateMinimum">
                                                ${{ job.rateRange.rateMinimum }} - ${{ job.rateRange.rateMaximum }}{{ job.rateOption === 'hourly' ? '/hour' : '/year' }}
                                            </ng-container>
                                            <ng-container *ngIf="job.rate && !job.rateRange?.rateMinimum">
                                                {{ job.rate }}{{ job.rateOption === 'hourly' ? '/hour' : '/year' }}
                                            </ng-container>
                                            <ng-container *ngIf="!job.rate && job.rateOption === 'experience'">Depends On Experience</ng-container>
                                            <ng-container *ngIf="job.rateOption === '' || job.rateOption === 'none'">Not Specified</ng-container>
                                        </span>
                                    </div>
                                    <div class="col-6 lg:col-4 flex flex-column">
                                        <span class="text-xs text-primary-900 font-medium">Location</span>
                                        <span class="text-black-alpha-60">
                                            <span *ngIf="job.isRemote">Remote</span>
                                            <span *ngIf="!job.isRemote">{{ job.city }}, {{ job.state }}, {{ job.postalCode }}</span>
                                        </span>
                                    </div>
                                    <div class="col-6 lg:col-4 flex flex-column" *ngIf="job.company">
                                        <span class="text-xs text-primary-900 font-medium">Company</span>
                                        <span class="text-black-alpha-60">{{ job.company }}</span>
                                    </div>
                                </div>
                                <div class="mt-2 flex gap-2">
                                    <p-button label="description" (click)="openDetailModal(job, 'description')" [rounded]="true" size="small"></p-button>
                                    <p-button label="requirements" (click)="openDetailModal(job, 'requirement')" [rounded]="true" size="small"></p-button>
                                    <p-button label="responsibilities" (click)="openDetailModal(job, 'responsibility')" [rounded]="true" size="small"></p-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
<p-dialog [header]="detailModalHeader" [modal]="true" [(visible)]="detailModalVisible" [style]="{width: '50vw'}" [draggable]="false" [resizable]="false">
    <p class="mt-2 break-words" style="white-space: pre-line; word-break: break-word;" [innerHTML]="sanitizer.bypassSecurityTrustHtml(detailModalContent)"></p>
</p-dialog>
